<template>
  <div class="result chatbot-product">
    <div class="img-wpr">
      <img :src="renderedImg" alt="">
    </div>
    <div class="specs">
      <p v-if="price" class="sale-price"><span v-if="product.priceQuantity">{{ `${product.priceQuantity} ` }}</span>${{
        price }}<span v-if="product[`promoUnit${languageSuffix}`]" class="unit">{{ ` ${product[`promoUnit${languageSuffix}`]}` }}</span></p>
      <p v-if="product.brandDescription" class="brand-description">{{ product.brandDescription }}</p>
      <p class="name">{{ product[`product${languageSuffix}`] }}</p>
      <p class="details">{{ product[`body${languageSuffix}`] }}</p>
      <p v-if="product.sku" class="sku">{{ product.sku }}</p>
    </div>
    <product-click-regions :block-data="product.blockData" :page="{}" :product="product" :is-visible="true" v-on="$listeners" class="overrideStyles" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { PRODUCT_REGION_CLICK_WITH_SKU, PRODUCT_REGION_CLICK } from "@/components/block/BlockEvents";
import ProductClickRegions from "@/components/block/elements/ProductClickRegions.vue";

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  components: { ProductClickRegions, },
  data() {
    return {
      flyerIdAtMount: null
    }
  },

  computed: {
    ...mapGetters(['language']),
    ...mapState('landingPage', ['flyerId']),

    renderedImg() {
      return this.product.productImage || this.product.blockData?.images[1]?.image || ''
    },
    
    price() {
      return this.product.salePrice || this.product.salePriceFr || this.product.regularPrice || this.product.regularPriceFr;
    },

    languageSuffix() {
      return this.language === 'fr' ? 'Fr' : 'En';
    }
  },
  methods: {
    ...mapActions('events', ['triggerEvent']),
    
    onClick() {

      this.triggerEvent({ 'event': 'linkClick', data: this })
      const clickRegionWithUrl = this.product.clickRegions.find(clickRegion => clickRegion.url)
      if (clickRegionWithUrl) {
        this.triggerEvent({ 'event': PRODUCT_REGION_CLICK_WITH_SKU, data: this })
        //Let the PDP feature handle what happens
        //window.open(clickRegionWithUrl.url)
        return
      }
      this.triggerEvent({ 'event': PRODUCT_REGION_CLICK, data: this.product })
      this.$emit('onRegionClick', this, 'productRegion');

      
      // console.log('product clicked', this.flyerIdAtMount, this.flyerId);
      // if (this.flyerIdAtMount === this.flyerId) {
      //   this.$root.$emit('trigger-scroll-to-sku', this.product.sku);
      // } else {
      //   Rest.NavigateToFlyer(this.flyerIdAtMount);
      // }
    }
  },

  mounted() {
    if (!this.flyerIdAtMount) {
      this.flyerIdAtMount = this.flyerId;
    }
  }
}
</script>

<style scoped lang="scss">
.result {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  border: none;
  background: none;
  padding: 16px 0;
  text-align: left;
  width: 100%;
  transition: background-color 0.3s;
  position: relative;

  &:hover, &:focus {
    background-color: rgba(255, 255, 255, 0.5);
    outline: none;
  }

  .img-wpr {
    align-self: center;
    width: 100%;
    height: 112px;
    flex-shrink: 0;
    border: 1px solid #F0F0F0;
    
    img {
      object-fit: contain;
      padding: 4px;
      width: 100%;
      height: 100%;
    }
  }

  .specs {
    display: flex;
    flex-direction: column;
  }

  .sale-price {
    font-size: 24px;
    font-weight: 700;
    color: #EE3326;

    .unit {
      font-size: 14px;
    }
  }

  .name {
    font-size: 13px;
    font-weight: 700;
  }

  .details {
    font-size: 11px;
    padding-top: 4px;
  }
}
</style>

<style lang="scss">
.chatbot-product .product-click-region {
  position: absolute;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 99 !important;
}
</style>